export interface ReplyTemplate {
  id: string;
  title: string;
  body: string;
}
export interface ReplyVariable {
  key: string;
  label: string;
  value?: string;
}
export const REPLY_MAX_LENGTH = 8000;
/** One pass, literal text only: supplied values cannot expand more variables or markup. */
export function resolveReplyTemplate(body: string, variables: readonly ReplyVariable[]) {
  const allowed = new Map<string, ReplyVariable>();
  const duplicates = new Set<string>();
  for (const variable of variables) {
    if (!/^[a-z][a-z0-9_]*$/.test(variable.key)) continue;
    if (allowed.has(variable.key)) duplicates.add(variable.key);
    allowed.set(variable.key, variable);
  }
  const used = new Set<string>(),
    missing = new Set<string>();
  const text = body.replace(/\{\{([^{}]*)\}\}/g, (token, raw: string) => {
    const key = raw.trim(),
      variable = allowed.get(key);
    used.add(key);
    if (!variable || duplicates.has(key) || !variable.value?.trim()) {
      missing.add(key);
      return token;
    }
    return variable.value;
  });
  const malformed = /\{\{\{|\}\}\}/.test(body) || /\{\{|\}\}/.test(body.replace(/\{\{[^{}]*\}\}/g, ''));
  const tooLong = body.length > REPLY_MAX_LENGTH || text.length > REPLY_MAX_LENGTH;
  return {
    text,
    used: [...used],
    missing: [...missing],
    malformed,
    tooLong,
    ready: missing.size === 0 && !malformed && !tooLong && text.trim().length > 0,
  };
}
